module.exports = __webpack_public_path__ + "static/media/otylia.b3983160.jpg";